import React, { useEffect, useState } from "react";
import { Select, Table, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import { FiEdit } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";
import "./WorkspacesHistory.css";
import { workspaces_Quick_Action_HistoryHandler } from "../../../../../Redux/Actions/user/WorkspaceQuickHistory";
const SearchIcon = "/assets/SearchIcon.svg";
let { Option } = Select;
const WorkspacesHistory = () => {
  const Navigate = useNavigate();
  const parms = useParams();
  const workspace_id = parms.id;
  let dispatch = useDispatch();
  const workspaceQuickactionsHistoryData = useSelector(
    (state) =>
      state?.workspaces_QuickHistory_Data?.workspace_quickactionsHistory_data
        ?.data
  );
  const [searchValue, setSearchValue] = useState(null);
  const itemsPerPage = workspaceQuickactionsHistoryData?.per_page;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const formatTimestamp = (timestamp) => {
    return timestamp ? format(new Date(timestamp), "dd/MM/yyyy") : "";
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(
      workspaces_Quick_Action_HistoryHandler(
        workspace_id,
        searchValue ? searchValue : "",
        "",
        page
      )
    );
  };
  const columns = [
    {
      title: "Output Name",
      dataIndex: "output_name",
      key: "output_name",
      sorter: (a, b) => a.output_name - b.output_name,
    },
    {
      title: "Output",
      dataIndex: "output",
      key: "output",
      sorter: (a, b) => a.output - b.output,
      width: 800,
    },
    {
      title: "QuickAction",
      dataIndex: "quick_action",
      key: "quick_action",
      sorter: (a, b) => a.quick_action - b.quick_action,
    },
    {
      title: "User",
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => a.first_name - b.first_name,
      render: (text, record) => (
        <span>
          {record.first_name} {record.last_name}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => a.date - b.date,
      render: (text, record) => formatTimestamp(record.date),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (text, record) => (
        <div>
          <Button
            className="workspaces_QuickHistory_Data_view_actions"
            onClick={() => {
              let navigateObj = {
                id: record?.action_run_id,
                Qaid: record?.quick_action_id,
              };

              const queryParams = new URLSearchParams(navigateObj).toString();
              const queryParamsObject = Object.fromEntries(
                new URLSearchParams(queryParams)
              );

              Navigate(
                `/workspaces/runQuickActionHistory/${queryParamsObject?.id}/${queryParamsObject?.Qaid}`
              );
            }}
          >
            <IoEyeOutline />
          </Button>
        </div>
      ),
    },
  ];

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const handleSearch = debounce((e) => {
    let value = e.target.value;
    let encodedValue = encodeURIComponent(value);
    if (encodedValue?.length) {
      setSearchValue(encodedValue);
    }
    if (!encodedValue.length) {
      dispatch(
        workspaces_Quick_Action_HistoryHandler(workspace_id, "", "", "")
      );
    }
  }, 1000);

  useEffect(() => {
    if (searchValue?.length > 3) {
      dispatch(
        workspaces_Quick_Action_HistoryHandler(
          workspace_id,
          searchValue,
          "",
          ""
        )
      );
    }
  }, [searchValue]);

  useEffect(() => {
    if (workspace_id) {
      dispatch(
        workspaces_Quick_Action_HistoryHandler(workspace_id, "", "", "")
      );
    }
  }, [workspace_id]);

  const handleSortChange = (sortvalue) => {
    dispatch(
      workspaces_Quick_Action_HistoryHandler(workspace_id, "", sortvalue)
    );
  };
  return (
    <div>
      <div className="my-history-div-1">
        <div className="relative search-container">
          <input
            type="text"
            placeholder="Search data here"
            className="search-from-logs"
            onChange={(e) => handleSearch(e)}
          />
          <img src={SearchIcon} alt="" className="search-icon" />
        </div>
        <div>
          <Select
            defaultValue="Sort By"
            className="workspace-select-class-div"
            onChange={handleSortChange}
          >
            <Option value="output_name"> Output Name</Option>
            <Option value="created_at"> Created At</Option>
          </Select>
        </div>
      </div>

      <div className="my-history-div-2">
        <Table
          className="mytable mytable-sorter"
          columns={columns}
          dataSource={workspaceQuickactionsHistoryData?.data}
          // size='middle'
          pagination={{
            pageSize: workspaceQuickactionsHistoryData?.per_page,
            total: workspaceQuickactionsHistoryData?.total,
            showSizeChanger: false,
            onChange: handlePageChange,
          }}
        />
      </div>
    </div>
  );
};

export default WorkspacesHistory;
